import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  ListItemIcon,
  Button,
  DialogActions,
} from "@mui/material";
import { db } from "../firebase-config";
import { collection, getDocs } from "firebase/firestore";

const UserSelectPopup = ({ open, onClose, onSelectUser, selectedUsers }) => {
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const usersRef = collection(db, "users");
      const snapshot = await getDocs(usersRef);
      const userList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(userList);
    };

    if (open) {
      fetchUsers();
      setSelected(selectedUsers || []);
    }
  }, [open, selectedUsers]);

  const toggleSelect = (user) => {
    setSelected((prev) =>
      prev.some((u) => u.id === user.id)
        ? prev.filter((u) => u.id !== user.id)
        : [...prev, user]
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Select Users</DialogTitle>
      <DialogContent>
        <List>
          {users.map((user) => (
            <ListItem
              key={user.id}
              button
              onClick={() => toggleSelect(user)}
            >
              <ListItemIcon>
                <Checkbox checked={selected.some((u) => u.id === user.id)} />
              </ListItemIcon>
              <ListItemText primary={user.email || "No Email"} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => {
            onSelectUser(selected);
            onClose();
          }}
          color="primary"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserSelectPopup;
